import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/vevo/mascot_peek.png'


const _hoisted_1 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex align-center justify-space-between" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_VueLoading = _resolveComponent("VueLoading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      variant: "outlined",
      class: "ma-3 pa-3 ai-report-entry",
      onClick: _ctx.toAiReport
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "VEVO",
            style: {"width":"28px","height":"28px","object-fit":"contain"}
          }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "text-subtitle-2 font-weight-bold" }, "VEVOレポート"),
            _createElementVNode("div", { class: "text-caption text-grey" }, "3か月単位の発達まとめを確認・再生成")
          ], -1)),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_icon, { color: "primary" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onClick"]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "font-weight-bold pa-4" }, "クラス選択", -1)),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClass, (clas, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: index,
                  onClick: ($event: any) => (_ctx.toClassRecords(clas.classId))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(clas.className) + " ", 1),
                        (_ctx.myClass && _ctx.myClass.classId === clas.classId)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              color: "primary",
                              class: "mx-2",
                              outlined: "",
                              small: ""
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("担当クラス", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_VueLoading, { height: '50vh' })
        ]))
  ]))
}